export default {
	"1e42ed0a7c08b9483c6b6eab3a6dd33d": "商品詳情頁_優惠券點擊"
}
